export class FotoWareSettings {

  constructor(
    public id?: number,
    public customerId?: string,
    public urlPrefix?: string,
    public clientId?: string,
    public clientSecret?: string,
  ) {
  }
}
